import { useContext, useMemo } from "react";
import { useRCAMainStyles } from "../RCA.styles";
import RCAActionPlansFilters from "./components/RCAActionPlansFilters";
import { Divider } from "@mui/material";
import { MainTable } from "components";
import { useTableOperations } from "components/MainTable/hooks/useTableOperations";
import { ActionPlanEntity } from "entities/RCA/ActionPlanEntity/ActionPlanEntity";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import useRCAActionPlansColumns from "./useRCAActionPlansColumns";
import { useStyles } from "./RCAActionPlans.styles";
import { CORPORATE_BACKOFFICE_PATHS } from "constants/constants";
import { useNavigate } from "react-router-dom";
import { RCAActionPlanFiltersContextProvider } from "contexts/RCAActionPlanFiltersContext/RCAActionPlanFiltersContextProvider";
import { RCAActionPlanFiltersContext } from "contexts/RCAActionPlanFiltersContext/RCAActionPlanFiltersContext";

const RCAActionPlansContent = () => {
    const mainClasses = useRCAMainStyles();
    const classes = useStyles();
    const navigate = useNavigate();
    const { handleRequestSort, handleChangeRowsPerPage, handleChangePage, order, orderBy, page, rowsPerPage } =
        useTableOperations();
    const { filters } = useContext(RCAActionPlanFiltersContext);

    const queryTableOperationFilters = useMemo(
        () => ({
            order,
            orderBy,
            limit: rowsPerPage,
            offset: page * rowsPerPage,
        }),
        [order, orderBy, rowsPerPage, page],
    );

    const { loading, actionPlans, apolloQueryError, refetch, totalCount } = ActionPlanEntity.GetAllActionPlans(
        queryTableOperationFilters,
        filters,
    );
    const tableColumns = useRCAActionPlansColumns(refetch) as unknown as IMainTableColumn[];
    return (
        <div className={mainClasses.mainWrapper}>
            <RCAActionPlansFilters />
            <div className={mainClasses.contentWrapper}>
                <div className={`${mainClasses.contentCard} ${classes.cardWrapper}`}>
                    <Divider />
                    <MainTable
                        maxHeight={false}
                        onRowClick={(row: { action_plan_id?: number }) => {
                            navigate(
                                `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_ACTION_PLANS.ROOT}/${row.action_plan_id}`,
                                {
                                    state: {
                                        from: `/${CORPORATE_BACKOFFICE_PATHS.ROOT_PATH}/${CORPORATE_BACKOFFICE_PATHS.RCA.ROOT}/${CORPORATE_BACKOFFICE_PATHS.RCA.RCA_ACTION_PLANS.ROOT}`,
                                    },
                                },
                            );
                        }}
                        customStyle={`${mainClasses.contentTable}`}
                        customStyleTypography={{ width: "100%" }}
                        paperElevation={0}
                        paperCustomStyle={mainClasses.contentTablePaper}
                        columns={tableColumns}
                        tableCellCustomStyle={mainClasses.contentTableCell}
                        rows={!loading && !apolloQueryError ? actionPlans : []}
                        loading={loading}
                        tableOperationsValues={{ order, orderBy, page, rowsPerPage }}
                        handleRequestSortParent={handleRequestSort}
                        handleChangeRowsPerPageParent={handleChangeRowsPerPage}
                        handleChangePageParent={handleChangePage}
                        querySorted={!!orderBy}
                        pagination
                        count={totalCount}
                    />
                </div>
            </div>
        </div>
    );
};

const RCAActionPlans = () => {
    return (
        <RCAActionPlanFiltersContextProvider>
            <RCAActionPlansContent />
        </RCAActionPlanFiltersContextProvider>
    );
};

export default RCAActionPlans;
